// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"39":"9498bd9c","599":"36bf2949","955":"1ab4563b"}[chunkId] + ".chunk.js";
};